module.exports = __webpack_public_path__ + "static/media/020-telephone-3.778ebd28.png";